/* @ngInject */
function campaignActionsService ($translate, CONSTANTS, ConnectorWebService, Utils, ToastService, SegmentService) {
  const service = {
    getCampaignActions,
    getCampaignActionDetails,
    createCampaignAction,
    updateCampaignAction,
    sanitizeAction,
    handleSaveActionError,
    changeCampaignActionPublishedStatus,
    archiveCampaignAction,
    getUserActions,
    getCampaignActionMaterials,
    downloadCampaignActionMaterials,
    sendCreateCampaignActionEvent,
    validateScheduleDateOnTemplateLink,
    getSelectedScheduleDate,
    findScheduleDateInMaterials,
    getPublicationStatus,
    getVisibilityLabel,
    unpublishCampaignAction
  }
  return service

  function getCampaignActions (campaignId) {
    if (!campaignId) {
      throw new Error('campaignId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS, [campaignId])
    return ConnectorWebService.get(url)
  }

  function getCampaignActionDetails (campaignId, actionId) {
    if (!campaignId || !actionId) {
      throw new Error('campaignId or actionId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS_ID, [campaignId, actionId])
    return ConnectorWebService.get(url)
  }

  function createCampaignAction (campaignId, action) {
    if (!campaignId || !action) {
      throw new Error('campaignId or action cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS, [campaignId])
    return ConnectorWebService.post(url, action)
  }

  function updateCampaignAction (campaignId, actionId, action) {
    if (!campaignId || !actionId || !action) {
      throw new Error('campaignId, actionId or action cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS_ID, [campaignId, actionId])
    return ConnectorWebService.put(url, action)
  }

  function sanitizeAction (action) {
    if (!action.briefingAuditId) action.briefingAuditId = undefined
    if (!action.postId) action.postId = undefined
    if (!action.artIds) action.artIds = undefined
    if (!action.expirationDate) action.expirationDate = undefined
    if (!action.publicationDate) action.publicationDate = undefined
  }

  function handleSaveActionError (error) {
    const reason = error.data.reason.toLowerCase()

    if (reason.includes('publication')) {
      ToastService.showErrorToast($translate.instant('campaignEdit.actions.startDateError'))
    } else if (reason.includes('expiration')) {
      ToastService.showErrorToast($translate.instant('campaignEdit.actions.expirationDateError'))
    } else {
      ToastService.defaultErrorToast()
    }
  }

  function changeCampaignActionPublishedStatus (campaignId, publish) {
    if (!campaignId) {
      throw new Error('campaignId is required')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS_ID_PUBLISH, [campaignId])
    return ConnectorWebService.put(url, { publish })
  }

  function archiveCampaignAction (campaignId, actionId) {
    if (!campaignId || !actionId) {
      throw new Error('campaignId or actionId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS_ID_ARCHIVE, [campaignId, actionId])
    return ConnectorWebService.put(url)
  }

  function getUserActions () {
    const url = CONSTANTS.URL_USERS_ME_CAMPAIGN_ACTIONS
    return ConnectorWebService.get(url)
  }

  function getCampaignActionMaterials (campaignId, actionId) {
    if (!campaignId || !actionId) {
      throw new Error('campaignId or actionId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS_ID_MATERIALS, [campaignId, actionId])
    return ConnectorWebService.get(url)
  }

  function downloadCampaignActionMaterials (campaignId, actionId) {
    if (!campaignId || !actionId) {
      throw new Error('campaignId or actionId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS_ID_MATERIALS_DOWNLOAD, [campaignId, actionId])
    return Utils.downloadFile(url)
  }

  function sendCreateCampaignActionEvent (campaign, action) {
    const actionContents = {
      ART: 'Art',
      AUDIT: 'Checklist',
      POST: 'Announcement'
    }

    SegmentService.track('campaign-action-create', {
      campaign_id: campaign.id,
      action_content: actionContents[action.type]
    })
  }

  function validateScheduleDateOnTemplateLink (material, scheduleDate) {
    if (!scheduleDate) {
      return true
    }

    const activeScheduleDate = material.templateScheduleDate || material.scheduledDate
    if (!activeScheduleDate || activeScheduleDate === scheduleDate) return true
    return false
  }

  function getSelectedScheduleDate (selectedMaterials, scheduleDate) {
    if (!scheduleDate || !selectedMaterials.length) return null

    let found = false
    let index = 0

    while (!found && index < selectedMaterials.length) {
      const activeScheduleDate = selectedMaterials[index].templateScheduleDate || selectedMaterials[index].scheduledDate
      if (activeScheduleDate === scheduleDate) {
        found = true
      }

      index++
    }

    return found ? scheduleDate : null
  }

  function findScheduleDateInMaterials (materials) {
    if (!materials.length) return null

    const material = materials.find(material => material.templateScheduleDate || material.scheduledDate)
    return material ? material.templateScheduleDate || material.scheduledDate : null
  }

  function getPublicationStatus (action) {
    if (action.wasUnpublished) return 'EXPIRED'
    if (!action.isActionPublished) return 'SCHEDULED'

    if (action.expirationDate && new Date(action.expirationDate) < new Date()) {
      return 'EXPIRED'
    }

    return 'PUBLISHED'
  }

  function getVisibilityLabel (action) {
    return action.publicationStatus === 'PUBLISHED' ? $translate.instant('visibleToUser') : $translate.instant('invisibleToUser')
  }

  function unpublishCampaignAction (campaignId, actionId) {
    if (!campaignId || !actionId) {
      throw new Error('campaignId or actionId cannot be null')
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CAMPAIGNS_ID_ACTIONS_ID_UNPUBLISH, [campaignId, actionId])
    return ConnectorWebService.put(url)
  }
}

export { campaignActionsService }
